App.controller('HealthPzuwCtrl', ['$rootScope', '$scope', '$sce', '$state', '$http', function ($rootScope, $scope, $sce, $state) {
    if (!$rootScope.CONFIGURATOR.healthInsurancePzuwEnabled) {
        $state.go('root.dashboard');
    }
}]);
